import React from 'react';
import BaseIcon from './BaseIcon';

class Clock7Icon extends BaseIcon {
    render() {
        return (<svg version='1.1' id='Clock7Icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 800'>
            <path
                fill={ this.props.primary }
                d='M399.7,173.4c-15.2,0-27.5,12.3-27.5,27.5v190.5L309.6,500c-7.6,13.2-3.1,30,10.1,37.6c4.3,2.5,9.1,3.7,13.7,3.7
                c9.5,0,18.8-4.9,23.8-13.8l66.3-114.9c0,0,0-0.1,0.1-0.1c0.2-0.3,0.4-0.7,0.5-1c0-0.1,0.1-0.2,0.1-0.2c0.2-0.3,0.3-0.7,0.5-1
                c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.3-0.6,0.4-1c0-0.1,0.1-0.2,0.1-0.4c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.2,0.1-0.3,0.2-0.5
                c0.1-0.2,0.2-0.5,0.2-0.7c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.1-0.4,0.1-0.6c0.1-0.3,0.1-0.5,0.2-0.8c0-0.1,0.1-0.3,0.1-0.4
                c0.1-0.3,0.1-0.6,0.2-1c0-0.1,0-0.2,0-0.3c0.1-0.4,0.1-0.7,0.1-1.1c0-0.1,0-0.2,0-0.2c0-0.4,0.1-0.8,0.1-1.2c0-0.1,0-0.1,0-0.2
                c0-0.4,0-0.8,0-1.2c0,0,0-0.1,0-0.1V200.9C427.2,185.7,414.9,173.4,399.7,173.4z'
            />

            <path
                fill={ this.props.primary }
                d='M710.7,267.5c-17-40.2-41.3-76.2-72.3-107.2c-31-31-67-55.3-107.2-72.3C489.7,70.5,445.5,61.6,400,61.6
                s-89.7,8.9-131.3,26.5c-40.2,17-76.2,41.3-107.2,72.3c-31,31-55.3,67-72.3,107.2c-17.6,41.6-26.5,85.8-26.5,131.3
                s8.9,89.7,26.5,131.3c17,40.2,41.3,76.2,72.3,107.2s67,55.3,107.2,72.3C310.3,727.1,354.5,736,400,736s89.7-8.9,131.3-26.5
                c40.2-17,76.2-41.3,107.2-72.3s55.3-67,72.3-107.2c17.6-41.6,26.5-85.8,26.5-131.3S728.3,309.1,710.7,267.5z M599.5,598.3
                C546.2,651.6,475.4,681,400,681c-75.4,0-146.2-29.4-199.5-82.7c-53.3-53.3-82.7-124.2-82.7-199.5c0-75.4,29.4-146.2,82.7-199.5
                c53.3-53.3,124.2-82.7,199.5-82.7c75.4,0,146.2,29.4,199.5,82.7c53.3,53.3,82.7,124.2,82.7,199.5
                C682.2,474.2,652.8,545,599.5,598.3z'
            />
        </svg>);
    }
}

export default Clock7Icon;
